/**
 * @file
 * ocseo behaviors.
 */
(function ($, Drupal) {

    'use strict';
  
    Drupal.behaviors.ocseo = {
      attach (context, settings) {
  
        console.log('It works!');
  
      }
    };
    var full_width_h = 0;
    if($('.learn-seo-online-classes-training #content').length){
      full_width_h = $('.main-content.internal .full-width').eq(0).outerHeight();
      $(':root').css('--fullWidthH',full_width_h + 'px');
    }
    var lastWindowWidth = $(window).width();
    function resize_banner_image(){
      if($('.banner-img').length){
        var banner_bg_pos = $('.banner-img').eq(0).position();
        $('.banner-img img').eq(0).on('load',function(){
          console.log(banner_bg_pos.top, $(this).outerHeight(true));
          $(':root').css({'--banner-background-height': (banner_bg_pos.top + $(this).outerHeight(true)-42) + 'px'});
        });
      }
    }
    $('.tab-item').each(function(el){
      if($(this).hasClass('last-tab')){
        //console.log($(el));
        $(this).on('mouseenter',function(){
          $('.tab-content').each(function(e){
            if($(this).hasClass('active')){
                $(this).find('a').find('img').parent().css({'borderRadius':'0px 0px 10px 10px'});
              }
          });
        });
        $(this).on('mouseout',function(){
          $('.tab-content').find('a').find('img').parent().css({'borderRadius':''});
        });
      }
      if($(this).hasClass('first-tab')){
        //console.log($(el));
        $(this).on('mouseenter',function(){
          $('.tab-content').each(function(e){
            if($(this).hasClass('active')){
                $(this).find('a').find('img').parent().css({'borderRadius':'0px 0px 10px 10px'});
              }
          });
        });
        $(this).on('mouseout',function(){
          $('.tab-content').find('a').find('img').parent().css({'borderRadius':''});
        });
      }
    });
    if($('.faq-content').length){
      $('.faq-content .faq-content-wrapper .faq-section .faq-item .question').on('click', function(){
          $(this).parent().toggleClass("expanded");
          $(this).parent().find('.answer').slideToggle();
      });
  }
    if($('.footer-wrapper > .cert').length && $('.footer-wrapper > .cert').is(":visible")){
      $('.footer-wrapper').css({'--background-height': (($('.footer-wrapper').outerHeight(true) - $('.footer-wrapper > .cert').outerHeight(true))  - 0) + 'px'});
    }else{
      $('.footer-wrapper').css({'--background-height': (($('.footer-wrapper').outerHeight(true))  - 0) + 'px'});
    }
    $(window).on('resize',function(){
      if($('.learn-seo-online-classes-training #content').length){
        full_width_h = $('.learn-seo-online-classes-training .main-content.internal .full-width').eq(0).outerHeight();
        $(':root').css('--fullWidthH',full_width_h + 'px');
      }
      if($('.footer-wrapper > .cert').length && $('.footer-wrapper > .cert').is(":visible")){
      $('.footer-wrapper').css({'--background-height': (($('.footer-wrapper').outerHeight(true) - $('.footer-wrapper > .cert').outerHeight(true)) - 0) + 'px'});
      }else{
        $('.footer-wrapper').css({'--background-height': (($('.footer-wrapper').outerHeight(true)) - 0) + 'px'});
      }
      if($(window).width() <= 768){
        resize_banner_image();
        if($('.footer-wrapper > .cert').length && $('.footer-wrapper > .cert').is(":visible")){
          $('.footer-wrapper').css({'--background-height': (($('.footer-wrapper').outerHeight(true) - $('.footer-wrapper > .cert').outerHeight(true)) - 0) + 'px'});
          }else{
            $('.footer-wrapper').css({'--background-height': (($('.footer-wrapper').outerHeight(true)) - 0) + 'px'});
          }
      }
    });

    tabJs = (navContainer, navItems) => {
  
      let items = Array.prototype.slice.apply(document.querySelectorAll(navItems));
      let panels = Array.prototype.slice.apply(document.querySelectorAll('.tab-content'));
      
      document.getElementById(navContainer).addEventListener('click', e => {
        if(e.target.classList.contains('tab-item')){
          items.map(tab => tab.classList.remove('active'));
          panels.map((tab) => {
            tab.style.display='none';
            tab.classList.remove('active');
          });
          e.target.classList.add('active');
          panels.forEach((element) => {
            if(element.classList.contains(e.target.id)){
              element.classList.add('active')
              element.style.display='block';
            }
          });
        }
      }) 
    }
    if($('#tabContainer').length){
      //tabJs('tabContainer', '.tab-item');
      if($(window).width() > 768){
        $('#tabContainer .tab-item').on('click',function(e){
          $(this).parent().find('.tab-item').each(function(){
              $(this).eq(0).removeClass('active');
          });
          $('.tab-content').each(function(){
              $(this).eq(0).removeClass('active');
              $(this).eq(0).hide();
          });
          $(this).eq(0).addClass('active');
          var tab_content_id_map = $(this).eq(0).attr('id');
          $('.tab-content').each(function(){
            if($(this).eq(0).hasClass(tab_content_id_map)){
              $(this).eq(0).addClass('active').show();
            }
          });
        });
      }else{
        $('#tabContainer li').each(function(){
          //console.log(el,idx);
          //console.log($(this).eq(0).attr('id'));
          var tab_content = $('.container-tabs .tab-content.'+$(this).eq(0).attr('id')).clone();
          $('.container-tabs .tab-content.'+$(this).eq(0).attr('id')).remove();
          //console.log(tab_content[0].outerHTML);
          var tab_acc_content = $(this).eq(0).text() + tab_content[0].outerHTML;
          $(this).eq(0).html(tab_acc_content);
          $(this).on('click',function(){
            if( $(this).eq(0).hasClass('active')){
              $(this).eq(0).removeClass('active');
              $(this).find('.tab-content').each(function(){
                $(this).eq(0).removeClass('active');
                $(this).eq(0).hide()
              });
            }else{
            $(this).eq(0).addClass('active');
              $(this).find('.tab-content.'+ $(this).eq(0).attr('id')).addClass('active');
              $(this).find('.tab-content.'+ $(this).eq(0).attr('id')).show();
            }
          });
         });
      }
    }
    /*$('.watch-vedios a').magnificPopup({
      type: 'iframe',
      midClick: true
    });*/
    if($('.google-map-full').length){
      var gmsp_h = 254 / 636;
      $('.google-map-full').css({'height':(636 * gmsp_h)+'px' , 'width':'100%'});
    }
    var mobile_menu_p = $.magnificPopup.instance;
    $('.mobile-nav').on('click',function(e){ 
      mobile_menu_p.open({
        items: {
          src: '<div class="mobile-menu-wrapper"><div class="top-mob"><a href="/" class="logo-brand" title="OC SEO"></a><div class="close-btn mob-close-btn"></div></div> <ul class="mobile-menu">' + $('.main-menu').html() + '</ul></div>', // can be a HTML string, jQuery object, or CSS selector
          type: 'inline'
        }
      });
    });
    $(document).on('click','.mob-close-btn',function(e){
      mobile_menu_p.close();
    });
    $(document).on('click','.hp-cta', function(e){
      if($(this).attr('href') == '#the_popup_form'){
        e.preventDefault();
        var currentURL = window.location.href;
        $.magnificPopup.open({
          items: {
            src: '/webform/seo_services_form_popup/share/iframe-resizer/4.2.10?url_from='+currentURL
          },
          type: 'iframe',
          mainClass: 'mfp-popup-form',
          removalDelay: 300,
          preloader: true,
          fixedContentPos: false,
        });
      }
    });
    if($('#table-pricing').length){
      $(document).on('click','#table-pricing .btn', function(e){
        var currentURL = window.location.href;
        var s_pacakge = $(this).eq(0).parent().parent().attr('class');
        $.magnificPopup.open({
          items: {
            src: '/webform/seo_services_form_popup/share/iframe-resizer/4.2.10?url_from='+currentURL+'&package='+s_pacakge
          },
          type: 'iframe',
          mainClass: 'mfp-popup-form',
          removalDelay: 300,
          preloader: true,
          fixedContentPos: false,
        });
      });
    }
    $('.watch-vedios a, .youtube-popup').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      iframe:{
        patterns:{
          youtube:{
          index: 'youtube.com',
          id: 'v=',
          src: 'https://www.youtube.com/embed/%id%'
        },
      },
      srcAction:'iframe_src',
    },
      fixedContentPos: false
    });
    $(':root').css({'--responsive-container-width': ($(window).width() > 768 ? 636 : $(window).width()) + 'px'});
    $(':root').css({'--footer-logo': 'url(' + $('.footer-logo').find('img').attr('src') + ')'});
    if($(window).width() <= 768){
      $('.footer-wrapper').find('.row').each(function(){
        if($(this).hasClass('cert')){
          $(this).find('img').each(function(){
            if(!$(this).hasClass('cards-logo')){
              $(this).attr('src',$(this).data('responsive-src'));
              $(this).before('<h3 class="cert-title">' + $(this).data('responsive-title') + '</h3>');
              $(this).data('updated','true');
            }
          });
        }
      });
      if($('.package-matrix-content').length){
        $('.package-matrix-content .package').each(function(){
          $(this).eq(0).find('.heading').each(function(){
            if($(this).eq(0).hasClass('featured')){
              $(this).eq(0).parent().addClass('active');
            }
          });
        });
        $('.package-matrix-content .package .heading').on('click',function(e){
          //e.preventDefault();
          $(this).eq(0).parent().toggleClass('active');
        });
        $('.btn-see-all-features').on('click',function(){
          if($(this).eq(0).parent().is('p')){
            $(this).eq(0).parent().parent().parent().toggleClass('show-all');
          }
        });
      }
      $(document).on('click', '.dropdown-arrow', function(e){
        e.preventDefault();
        //alert('test');
        $(this).eq(0).parent().parent().find('.submenu').toggle();
        $(this).eq(0).toggleClass('shown');
      });
    }
    var $allVideos = $("iframe[src*='www.youtube.com'], iframe[src*='player.vimeo.com'], iframe[src*='www.youtube-nocookie.com']");
    console.log('iframe count: ' + $allVideos.length);
    if($(window).width() <= 768){ 
      if($('.brands-logo').length){
        $('.brands-logo').marquee({
          //speed in milliseconds of the marquee
          duration: 10000,
          //gap in pixels between the tickers
          gap: 0,
          //time in milliseconds before the marquee will start animating
          delayBeforeStart: 0,
          //'left' or 'right'
          direction: 'left',
          //true or false - should the marquee be duplicated to show an effect of continues flow
          duplicated: true
        });
      }
      if($allVideos.length){
        $allVideos.each(function() {  
          var newWidth = $(window).width();
          $(this).eq(0)
            .data('aspectRatio', $(this).eq(0).attr('height') / $(this).eq(0).attr('width'))
            .data('origHeigh', $(this).eq(0).attr('height'))
            .data('origWidth',  $(this).eq(0).attr('width'))
            // and remove the hard coded width/height
            .attr('height', newWidth * ( $(this).eq(0).attr('height') / $(this).eq(0).attr('width') ))
            .attr('width', newWidth);
            
        });
      }
      $('.content').find('iframe').each(function(){
        if($(this).parent().is('p')){
          var r_iframe = $(this).clone();
          //console.log('<p>'+r_iframe[0].outerHTML+'</p>');
          $(this).parent().after('<p class="iframe-video">'+ r_iframe[0].outerHTML + '</p>');
          $(this).parent().css({'margin-bottom':'10px'});
          $(this).remove();
        }
      });
      if($('#schema-videoobject').length){
        var vobj_height = $('#schema-videoobject object').eq(0).css('height');
        var vobj_width = $('#schema-videoobject object').eq(0).css('width');
        $('#schema-videoobject object').eq(0).css('height',($(window).width() * (parseInt(vobj_height, 10)/parseInt(vobj_width, 10))) + 'px');
         $('#schema-videoobject object').eq(0).css('width', $(window).width() + 'px');
      }
      if($('.google-map').length){
        var map_height = $('.google-map').eq(0).css('height');
        var map_width = $('.google-map').eq(0).css('width');
        $('.google-map').eq(0).css('height',($(window).width() * (parseInt(map_height, 10)/parseInt(map_width, 10))) + 'px');
        $('.google-map').eq(0).css('max-width', $(window).width() + 'px');
        $('.google-map').eq(0).css('width','100%');
      }
      
      if ($("body").hasClass("homepage")) {
        var fimage = '';
        if($('.content .hp-copy p').eq(0).find('img').eq(0).length){
          fimage = $('.content .hp-copy p').eq(0).find('img').eq(0).clone();
          $('.content .hp-copy p').eq(0).find('img').eq(0).remove();
          $('.content .hp-copy p').eq(0).before('<p>'+fimage[0].outerHTML+'</p>');
        }
      }
      //if($("body").hasClass("seo-services").hasClass('pricing-matrix2')){
        if($('.banner-img').length){
          $('.banner-img').find('img').eq(0).attr('src', $('.banner-img').data('src-mob')).removeAttr('width').removeAttr('height');
          resize_banner_image();
        }
      //}
      if($('.featured-clients').length){
        var client_logos = '';
        $('.featured-clients li').each(function(){
          client_logos = client_logos + $(this).eq(0).html();
        });
        $('.featured-clients').after('<div class="featured-clients-logo">' + client_logos + '</div');
        $('.featured-clients').hide();

        $('.featured-clients-logo').marquee({
          //speed in milliseconds of the marquee
          duration: 10000,
          //gap in pixels between the tickers
          gap: 17,
          //time in milliseconds before the marquee will start animating
          delayBeforeStart: 0,
          //'left' or 'right'
          direction: 'left',
          //true or false - should the marquee be duplicated to show an effect of continues flow
          duplicated: true,
        });
      }
      if($('.node').length){
        var fattr = 'gold';
        $('.node').each(function(){
          fattr = $(this).eq(0).attr('data-featured');
          if (typeof fattr !== 'undefined' && fattr !== false) {
            //console.log(fattr);
            $('.table-pricing table tr th').removeClass('active');
            $('.table-pricing table tr td').removeClass('active');
            $('.table-pricing table tr th').each(function(){
                if($(this).eq(0).hasClass(fattr)){
                  $(this).eq(0).addClass('active');
                }
            });
          }else{
            return false;
          }
        });
        if($('.table-pricing').length){
          var fattr = $('.table-pricing table tr th.featured').eq(0).data('value');
          console.log(fattr);
          if (typeof fattr !== 'undefined' && fattr !== false) {
            /*$('.table-pricing table tr td').each(function(){
              if($(this).eq(0).parent().hasClass('service-category')){
                $(this).eq(0).parent().find('td').each(function(){
                  $(this).eq(0).attr('colspan',2);
                  return false;
                });
              }
              if($(this).eq(0).hasClass(fattr)){
                $(this).eq(0).addClass('active');
              }
            });*/
            $('.table-pricing table tr.service-category td').eq(0).attr('colspan',2);
            $('.table-pricing table tbody tr td.'+fattr).addClass('active');
            $('.table-pricing table tfoot tr td.'+fattr).addClass('active');
            $('.next-link').on('click',function(e){
              //console.log($(this).parent().parent().parent().data('value'));
              $('.table-pricing table tr th').removeClass('active');
              $('.table-pricing table tr td').removeClass('active');
              var nex_val = $(this).eq(0).parent().parent().parent().data('next');
              $('.table-pricing table tr th').each(function(){
                if($(this).eq(0).hasClass(nex_val)){
                  $(this).eq(0).addClass('active');
                }
              });
              $('.table-pricing table tr td').each(function(){
                if($(this).eq(0).parent().hasClass('service-category')){
                  $(this).eq(0).parent().find('td').each(function(){
                    $(this).eq(0).attr('colspan',2);
                    return false;
                  });
                }
                if($(this).eq(0).hasClass(nex_val)){
                  $(this).eq(0).addClass('active');
                }
              });
            });
            $('.prev-link').on('click',function(e){
              //console.log($(this).parent().parent().parent().data('value'));
              $('.table-pricing table tr th').removeClass('active');
              $('.table-pricing table tr td').removeClass('active');
              var prev_val = $(this).eq(0).parent().parent().parent().data('prev');
              $('.table-pricing table tr th').each(function(){
                if($(this).eq(0).hasClass(prev_val)){
                  $(this).eq(0).addClass('active');
                }
              });
              $('.table-pricing table tr td').each(function(){
                if($(this).eq(0).parent().hasClass('service-category')){
                  $(this).eq(0).parent().find('td').each(function(){
                    $(this).eq(0).attr('colspan',2);
                    return false;
                  });
                }
                if($(this).eq(0).hasClass(prev_val)){
                  $(this).eq(0).addClass('active');
                }
              });
            });
          }
        }
      }
      /*if($('.container-tabs').length){
         $('#tabContainer li').each(function(){
          //console.log(el,idx);
          console.log($(this).eq(0).attr('id'));
          var tab_content = $('.container-tabs .tab-content.'+$(this).eq(0).attr('id')).clone();
          console.log(tab_content[0].outerHTML);
          var tab_acc_content = $(this).eq(0).text() + tab_content[0].outerHTML;
          $(this).eq(0).html(tab_acc_content);
         });
        /*$('.container-tabs .tab-content').each(function(){
          //console.log($(this));
          $('#tabContainer #'+ $(this).attr('id')).html($(this)[0].outerHTML);
          //$(this).remove();
        });
      }*/
    }
    if($('.webform-ajax-form-wrapper').length){
      $('.webform-ajax-form-wrapper').css('--form-width',(($('.webform-ajax-form-wrapper').eq(0).width() / 304) * 100) + '%');
    }
    $(window).resize(function() {
      $(':root').css({'--responsive-container-width': ($(window).width() > 768 ? 636 : $(window).width()) + 'px'});
      if($('.webform-ajax-form-wrapper').length){
        $('.webform-ajax-form-wrapper').css('--form-width',(($('.webform-ajax-form-wrapper').eq(0).width() / 304) * 100) + '%');
      }
      //console.log($(window).width());
      if($(window).width() <= 768){
        if($allVideos.length){
          $allVideos.each(function() {
            var $el = $(this);
            // Get parent width of this video
            var newWidth = $(window).width();
            $el
              .width(newWidth)
              .height(newWidth * $el.data('aspectRatio'));
          });
        }
        $('.content').find('iframe').each(function(){
          if(!$(this).parent().hasClass('iframe-video')){
            var r_iframe = $(this).clone();
            $(this).parent().after('<p class="iframe-video">'+ r_iframe[0].outerHTML +'</p>');
            $(this).parent().css({'margin-bottom':'10px'});
            $(this).remove();
          }
        });
        /*if($('.package-matrix-content').length){
          $('.package-matrix-content').find('.package').each(function(){
            $(this).find('.heading').each(function(){
              if($(this).hasClass('featured')){
                $(this).parent().addClass('active');
              }
            });
          });
          $('.package-matrix-content .package .heading').on('click',function(e){
            //e.preventDefault();
            $(this).parent().toggleClass('active');
          });
          $('.btn-see-all-features').on('click',function(){
            if($(this).parent().is('p')){
              $(this).parent().parent().parent().toggleClass('show-all');
            }
          });
        }*/
        $('.footer-wrapper .row.cert img').each(function(){
          //console.log($(this).attr('src'));
          //console.log($(this).not('.cards-logo').length);
          if($(this).not('.cards-logo').length){
            //console.log($(this).data('updated'));
            if($(this).data('updated') == false){
              $(this).attr('src',$(this).data('responsive-src'));
              $(this).before('<h3 class="cert-title">' + $(this).data('responsive-title') + '</h3>');
              $(this).data('updated','true');
            }
          }
        });
        /*if($('.container-tabs').length){
          $('.container-tabs .tab-content').each(function(){
            $('#tabContainer #'+$(this).attr('id')).html($(this)[0].outerHTML);
            $(this).remove();
          });
        }*/
       if(lastWindowWidth > 768 ){
          if($('#tabContainer').length){
            $('#tabContainer li').each(function(){
              var tab_content = $('.container-tabs .tab-content.'+$(this).eq(0).attr('id')).clone();
              $('.container-tabs .tab-content.'+$(this).eq(0).attr('id')).remove();
              //console.log(tab_content[0].outerHTML);
              var tab_acc_content = $(this).eq(0).text() + tab_content[0].outerHTML;
              $(this).eq(0).html(tab_acc_content);
              $(this).on('click',function(){
                if( $(this).eq(0).hasClass('active')){
                  $(this).eq(0).removeClass('active');
                  $(this).find('.tab-content').each(function(){
                    $(this).eq(0).removeClass('active');
                    $(this).eq(0).hide();
                  });
                }else{
                  $(this).eq(0).addClass('active');
                  $(this).find('.tab-content.'+ $(this).eq(0).attr('id')).addClass('active');
                  $(this).find('.tab-content.'+ $(this).eq(0).attr('id')).show();
                }
              });
            });
          }
          if ($("body").hasClass("homepage")) {
            var rfimage = '';
            if($('.content .hp-copy p').eq(0).find('img').eq(0).length){
              rfimage = $('.content .hp-copy p').eq(0).find('img').eq(0).clone();
              $('.content .hp-copy p').eq(0).find('img').eq(0).remove();
              $('.content .hp-copy p').eq(0).before('<p>'+rfimage[0].outerHTML+'</p>');
            }
          }
          //if($("body").hasClass("seo-services").hasClass('pricing-matrix2')){
            if($('.banner-img').length){
              $('.banner-img').find('img').eq(0).attr('src', $('.banner-img').data('src-mob')).removeAttr('width').removeAttr('height');
            }
         // }
          if($('.featured-clients').length && $('.featured-clients-logo').length == 0){
            var client_logos = '';
            $('.featured-clients li').each(function(){
              client_logos = client_logos + $(this).eq(0).html();
            });
            $('.featured-clients').after('<div class="featured-clients-logo">' + client_logos + '</div');
            $('.featured-clients').hide();
    
            $('.featured-clients-logo').marquee({
              //speed in milliseconds of the marquee
              duration: 10000,
              //gap in pixels between the tickers
              gap: 17,
              //time in milliseconds before the marquee will start animating
              delayBeforeStart: 0,
              //'left' or 'right'
              direction: 'left',
              //true or false - should the marquee be duplicated to show an effect of continues flow
              duplicated: true,
            });
          }

        }
      }else{
        $('.footer-wrapper .row.cert img').each(function(){
          //console.log($(this).attr('src'));
          //console.log($(this).not('.cards-logo').length);
          if($(this).not('.cards-logo').length){
            if($(this).data('updated')){
              $(this).attr('src',$(this).data('orig-src'));
              $(this).data('updated','false');
            }
          }
        });
        if(lastWindowWidth <= 768 ){
          if($('.container-tabs').length){
            /*$('.container-tabs .tab-content').each(function(){
              $('#tabContainer #'+$(this).attr('id')).html($(this)[0].outerHTML);
              $(this).remove();
            });*/
            $('#tabContainer .tab-item').each(function(){
              var tab_content = $('#tabContainer .tab-item .tab-content.'+$(this).eq(0).attr('id')).clone();
              $('.container-tabs').append(tab_content[0].outerHTML);
              $('#tabContainer .tab-item .tab-content.'+$(this).eq(0).attr('id')).remove(); 
            });
          }
          if ($("body").hasClass("homepage")) {
            var rrfimage = '';
            if($('.content .hp-copy p').eq(0).find('img').eq(0).length){
              rrfimage = $('.content .hp-copy p').eq(0).clone();
              //console.log($(rrfimage).html());
              $('.content .hp-copy p').eq(1).prepend($(rrfimage).html());
              $('.content .hp-copy p').eq(0).remove();
            } 
          }
          //if($("body").hasClass("seo-services").hasClass('pricing-matrix2')){
            if($('.banner-img').length){
              $('.banner-img > img').attr('src', $('.banner-img').data('src-orig')).attr('width',$('.banner-img').data('orig-width')).attr('height',$('.banner-img').data('orig-height'));
          //  }
          }
          $('.content').find('iframe').each(function(){
            if($(this).parent().hasClass('iframe-video')){
              $(this).css({'width':''})
              var rr_iframe = $(this).clone();
              $(this).parent().prev().append(rr_iframe[0].outerHTML);
              $(this).parent().prev().css({'margin-bottom':''});
              $(this).parent().remove();
            }
          });
          if($allVideos.length){
            $allVideos.each(function() {
              var $el = $(this);
              // Get parent width of this video
              $el
                .attr('height',$el.data('origHeight'))
                .attr('width',$el.data('origWidth'))
                .css({'width':''});
            });
          }
          if($('.featured-clients').length){
            if($('.featured-clients-logo').length){
              $('.featured-clients-logo').marquee("destroy");
              $('.featured-clients-logo').remove();
            }
            $('.featured-clients').show();
          }
        }
      }
      /*if($('#tabContainer').length){
        //tabJs('tabContainer', '.tab-item');
        if($(window).width() > 768){
          $('#tabContainer .tab-item').on('click',function(e){
            $(this).parent().find('.tab-item').each(function(){
              if($(this).eq(0).hasClass('active')){
                $(this).eq(0).removeClass('active');
              }
            });
            $('.tab-content').each(function(){
              if($(this).eq(0).hasClass('active')){
                $(this).eq(0).removeClass('active');
                $(this).eq(0).hide();
              }
            });
            $(this).addClass('active');
            $('.tab-content').each(function(){
              if($(this).eq(0).hasClass($(this).eq(0).attr('id'))){
                $(this).eq(0).addClass('active').show();
              }
            });
          });
        }else{
          $('#tabContainer li').each(function(){
            //console.log(el,idx);
            console.log($(this).eq(0).attr('id'));
            var tab_content = $('.container-tabs .tab-content.'+$(this).eq(0).attr('id')).clone();
            $('.container-tabs .tab-content.'+$(this).eq(0).attr('id')).remove();
            console.log(tab_content[0].outerHTML);
            var tab_acc_content = $(this).eq(0).text() + tab_content[0].outerHTML;
            $(this).eq(0).html(tab_acc_content);
           });
        }
      }*/
        if($('.google-map-full').length){
          var gmsp_h = 254 / $(window).width();
          $('.google-map-full').css({'height':($(window).width() * gmsp_h)+'px' , 'width':'100%'});
        }
        console.log('last width = ' + lastWindowWidth);
        lastWindowWidth = $(window).width();
        console.log('new width = ' + lastWindowWidth);
    }).resize();
    if($('.featured-clients-new').length){
      var SwiperTop = new Swiper('.featured-clients-new', {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
          delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
      });
    }
    if($('.plan-feature-package').length){
      $('.plan-feature-package .feature h3').on('click', function(e){
        e.preventDefault();
        if($(window).width() <= 768){
          $('.plan-feature-package .feature.active h3').css({'position':'','width':'','top':'','z-index':''});
          $(this).eq(0).parent().parent().find('.feature').removeClass('active');
        }
          $(this).eq(0).parent().toggleClass('active');
      })
    }
    if($('.tab-option .option').length){
      $('.tab-option .option .monthly-btn').on('click', function(e){
        e.preventDefault();
        if(!$(this).hasClass('active')){
          $(this).parent().removeClass('yearly').removeClass('monthly').addClass('monthly');
          $('.pricing-table').find('.price').each(function(){
            $(this).text($(this).data('monthly'));
          });
          $(this).addClass('active');
          $('.tab-option .option .yearly-btn').removeClass('active');
        }
      });
      $('.tab-option .option .yearly-btn').on('click', function(e){
        e.preventDefault();
        if(!$(this).hasClass('active')){
        $(this).parent().removeClass('yearly').removeClass('monthly').addClass('yearly');
        $('.pricing-table').find('.price').each(function(){
          $(this).text($(this).data('yearly'));
        });
        $(this).addClass('active');
        $('.tab-option .option .monthly-btn').removeClass('active');
      }
      });
    }
    if($(window).width() <= 768){
      if($('.pricing-table .package').length){
        $('.pricing-table .package').on('click', function(e){
          e.preventDefault();
           $('.pricing-table .package').removeClass('open').addClass('close');
           $('.pricing-table .package .header').removeClass('is-sticky').css('top','');
          if($(this).hasClass('open') || $(this).hasClass('close')){
            $(this).toggleClass('open close');
          }else{
            $(this).addClass('open');
          }
          $(this).find('.header').addClass('is-sticky').css('top',70 + 'px');
           $('html, body').animate({
              scrollTop: $(this).offset().top + 120
            }, 1000)
        });
      }
    }
    if($('.page-type-new-structure .the-head').length){
      var lastScrollTop = 0, delta = 50, scrollTimeout = 0;
      $(window).scroll(function(event){
         var st = $(this).scrollTop();
         if(Math.abs(lastScrollTop - st) <= delta)
          return;
        if ((st > lastScrollTop) && (lastScrollTop>0)) {
          // downscroll code
          $(".page-type-new-structure .the-head").css("top","-40px");
          $(".page-type-new-structure #wrapper").css("marginTop","130px");
          if($(window).width() <= 768){
            $(".page-type-new-structure .the-head").css("top","-50px");
            $(".page-type-new-structure #wrapper").css("marginTop","80px");
            var offset = $('#header').offset();
            var topPosition = offset.top;
            //console.log('Top: ' + topPosition);
            if($('.pricing-package-content .pricing-package-wrapper .pricing-table .package').length){
              var p_headtop_orig =$('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').offset().top;
              var p_footertop = $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .footer .button.mobile').offset().top;
              if($('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open').length){
                //console.log('package header: ' + $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').offset().top);
                if($('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').offset().top <= (topPosition + 120)){
                  $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').addClass('is-sticky');
                  $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').css('top',70 + 'px');
                }
                if((st + 120) >  p_footertop){
                  console.log('st ' + st +'footerb ' + p_footertop);
                  $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').removeClass('is-sticky');
                  $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').css('top','');
                }
              }
              if((st + 120) > $('.plan-feature-package .feature.active h3').offset().top && (st + 120) <  ($('.plan-feature-package .feature.active').offset().top + $('.plan-feature-package .feature.active').outerHeight(true))){
                $('.plan-feature-package .feature.active h3').css({'position':'fixed','width':'100%','top':'70px','z-index':'100'});
              }else{
                $('.plan-feature-package .feature.active h3').css({'position':'','width':'','top':'','z-index':''});
              }
            }
            //console.log('st ' + st + ' feature package: ' + $('.plan-feature-package .feature.active h3').offset().top);
          }
          clearTimeout(scrollTimeout);
          /*scrollTimeout = setTimeout(function() {
            // Code to execute when scrolling has stopped
            //console.log('Scrolling has stopped.');
            $(".page-type-new-structure .the-head").css("top","");
            $(".page-type-new-structure #wrapper").css("marginTop","");
            var offset = $('#header').offset();
            var topPosition = offset.top;
            var leftPosition = offset.left;
            console.log('Top: ' + topPosition + ', Left: ' + leftPosition);
            console.log('menu header: ' + (topPosition + 120));
            console.log('packaged header: ' + $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').offset().top);
            if($('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').offset().top <= (topPosition + 120)){
              $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').addClass('is-sticky');
              $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').css('top', 120 + 'px');
            }
          }, 600); // Adjust the timeout value (in milliseconds) as needed*/
        } else {
          // upscroll code
          clearTimeout(scrollTimeout);
          $(".page-type-new-structure .the-head").css("top","");
          $(".page-type-new-structure #wrapper").css("marginTop","");
          if($(window).width() <= 768){
            if($('.pricing-package-content .pricing-package-wrapper .pricing-table .package').length){
              if($('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open').length){
                $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').css('top',120 + 'px');
                if((st + 120) <= p_headtop_orig){
                  $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').removeClass('is-sticky');
                  $('.pricing-package-content .pricing-package-wrapper .pricing-table .package.open .header').css('top','');
                }
              }
            }
            if($('.plan-feature-package').length){
              if((st + 120) > $('.plan-feature-package .feature.active h3').offset().top && (st + 120) <  ($('.plan-feature-package .feature.active').offset().top + $('.plan-feature-package .feature.active').outerHeight(true))){
                $('.plan-feature-package .feature.active h3').css({'position':'fixed','width':'100%','top':'120px','z-index':'100'});
              }else{
                $('.plan-feature-package .feature.active h3').css({'position':'','width':'','top':'','z-index':''});
              }
            }
          }
        }
        //console.log('Scroll Top: ' + st);
        //console.log($('.toc-wrapper').length);
        if($(window).width() > 768){
          if($('.toc-wrapper').length){
            var single_article_ht = $('.single-article-content').outerHeight(true);
            if(st >= 415 && st < single_article_ht){
              $('.toc-wrapper').css('marginTop',((st + 342) - 760) + 'px');
            }else{
              $('.toc-wrapper').css('marginTop','0px');
            }
          }
        }
      lastScrollTop = st;
      });
    }
    //if($('.cat-options-wrapper .active-cat .selected-category').length){
    $(document).on('click', '.selected-category', function(e){
      e.preventDefault();
      if($(this).parent().parent().hasClass('active')){
        $(this).parent().parent().removeClass('active');
      }else{
        $(this).parent().parent().addClass('active');
      }
    });
    //}
  } (jQuery, Drupal));
  